import { IPositionResponseNew } from 'services/position/position.interface';

function convertAllPositionByExpertise(
  allPositions: IPositionResponseNew[],
): IPositionResponseNew[] {
  allPositions
    .sort((a, b) => a.orderNo - b.orderNo)
    .forEach(position =>
      position.knowledgeAreas
        .sort((a, b) => a.orderNo - b.orderNo)
        .forEach(knowledge => {
          knowledge.knowledge.levels.sort((a, b) => a.orderNo - b.orderNo);
          knowledge.selectedLevel.sort((a, b) => a.orderNo - b.orderNo);
        }),
    );

  return allPositions;
}

export { convertAllPositionByExpertise };
